/* tslint:disable */
/* eslint-disable */
/**
 * Assemblean Production Solutions
 * Produce the lean way with APCS
 *
 * The version of the OpenAPI document: 0.9.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Helper Serializer that is used to validate that the JSON automatic_shares-data
 * provided to the SharepointCreationSerializer contains the necessary fields.
 * @export
 * @interface APIAutomaticShareJsonRequest
 */
export interface APIAutomaticShareJsonRequest {
    /**
     * 
     * @type {string}
     * @memberof APIAutomaticShareJsonRequest
     */
    contact: string;
    /**
     * 
     * @type {string}
     * @memberof APIAutomaticShareJsonRequest
     */
    customInvitationMessage: string;
}

/**
 * Check if a given object implements the APIAutomaticShareJsonRequest interface.
 */
export function instanceOfAPIAutomaticShareJsonRequest(value: object): value is APIAutomaticShareJsonRequest {
    if (!('contact' in value) || value['contact'] === undefined) return false;
    if (!('customInvitationMessage' in value) || value['customInvitationMessage'] === undefined) return false;
    return true;
}

export function APIAutomaticShareJsonRequestFromJSON(json: any): APIAutomaticShareJsonRequest {
    return APIAutomaticShareJsonRequestFromJSONTyped(json, false);
}

export function APIAutomaticShareJsonRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): APIAutomaticShareJsonRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'contact': json['contact'],
        'customInvitationMessage': json['custom_invitation_message'],
    };
}

export function APIAutomaticShareJsonRequestToJSON(value?: APIAutomaticShareJsonRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'contact': value['contact'],
        'custom_invitation_message': value['customInvitationMessage'],
    };
}

